import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, Stethoscope, ArrowRight } from 'lucide-react';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const status = params.get('status');
  const msg    = params.get('msg');

  const isSuccess = status === 'success';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: .4 }}
        className="bg-white rounded-2xl shadow-xl border border-slate-100 p-10 w-full max-w-md text-center"
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg, #6366f1, #4f46e5)' }}>
            <Stethoscope size={17} className="text-white" />
          </div>
          <span className="font-bold text-slate-900 text-lg">Rostery</span>
        </div>

        {isSuccess ? (
          <>
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <CheckCircle size={32} className="text-emerald-500" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-3">Email verified!</h1>
            <p className="text-slate-500 text-sm leading-relaxed mb-8">
              Your email has been verified successfully. Our team will review your registration and send you an approval email — usually within 1 business day.
            </p>
            <Link to="/login"
              className="btn-primary w-full py-3 text-sm flex items-center justify-center gap-2">
              Go to Login <ArrowRight size={15} />
            </Link>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <XCircle size={32} className="text-red-500" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-3">Verification failed</h1>
            <p className="text-slate-500 text-sm leading-relaxed mb-3">
              {msg ? decodeURIComponent(msg) : 'The verification link is invalid or has expired.'}
            </p>
            <p className="text-slate-400 text-xs mb-8">
              Please register again to receive a new verification email.
            </p>
            <div className="flex flex-col gap-3">
              <Link to="/register"
                className="btn-primary w-full py-3 text-sm flex items-center justify-center gap-2">
                Register Again <ArrowRight size={15} />
              </Link>
              <Link to="/login"
                className="text-sm text-slate-500 hover:text-slate-700 transition-colors">
                Back to Login
              </Link>
            </div>
          </>
        )}
      </motion.div>
    </div>
  );
}
